import React from 'react';
import { MdMonitor } from 'react-icons/md';
import { useTracks, VideoTrack } from '@livekit/components-react';
import { Track } from 'livekit-client';

const ScreenShareView: React.FC = () => {
    const screenTracks = useTracks([Track.Source.ScreenShare]);
    const cameraTracks = useTracks([Track.Source.Camera]);

    if (screenTracks.length === 0 && cameraTracks.length === 0) {
        return (
            <div className="w-full h-full bg-gray-900 rounded-t-2xl flex flex-col items-center justify-center relative overflow-hidden">
                <div className="text-gray-500 flex flex-col items-center gap-4">
                    <MdMonitor className="w-16 h-16 opacity-50" />
                    <p>No one is sharing</p>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full h-full bg-gray-900 rounded-t-2xl flex flex-col overflow-hidden">
            {screenTracks.length > 0 && (
                <div className="flex-1 relative">
                    <VideoTrack trackRef={screenTracks[0]} className="w-full h-full object-contain" />
                    <div className="absolute top-4 left-4 bg-black/50 px-3 py-1.5 rounded-lg flex items-center gap-2 z-10">
                        <span className="text-white text-sm font-medium">
                            {screenTracks[0].participant.name || screenTracks[0].participant.identity}&apos;s screen
                        </span>
                    </div>
                </div>
            )}

            {cameraTracks.length > 0 && (
                <div
                    className={`flex gap-2 p-2 overflow-x-auto ${screenTracks.length > 0 ? 'h-24 flex-shrink-0' : 'flex-1 flex-wrap justify-center'
                        }`}
                >
                    {cameraTracks.map((track) => (
                        <div
                            key={track.participant.identity}
                            className="relative flex-shrink-0 rounded-lg overflow-hidden bg-gray-800"
                            style={{
                                width: screenTracks.length > 0 ? 128 : 240,
                                height: screenTracks.length > 0 ? 80 : 170,
                            }}
                        >
                            <VideoTrack trackRef={track} className="w-full h-full object-cover" />
                            <span className="absolute bottom-1 left-1 text-white text-xs bg-black/50 px-1 rounded">
                                {track.participant.name || track.participant.identity}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ScreenShareView;
